<template>
    <CustomerSearch/>
</template>
<script>
import CustomerSearch from 'operations/customer/customerSearch.vue'
export default {
    components:{
        CustomerSearch
    }
}
</script>